import React from 'react';
import moment from 'moment';
import PPMobileCardView from '../../../components/PPMobileCardView';

const Mobile = ({data, onDelete, onEdit}) => {
    const rows = [
        { label: 'Formula Name', value: data.formulaName, fullWidth: true, hideLabel: true, bold: true, fontSize: 14 },
        { label: 'Farm Name', value: data.farmName },
        { label: 'Shed Name', value: data.shedName },
        { label: 'Quantity', value: data.quantity },
        data.costperunit !== undefined && { label: 'Cost Per Unit', value: Number(data.costperunit).toFixed(2) },
        { label: 'Cost', value: data.cost != null ? Number(data.cost).toFixed(2) : data.cost },
    ].filter(Boolean);

    const menuItems = [
        { label: 'Edit', onClick: onEdit },
        { label: 'Delete', onClick: onDelete },
    ];

    return (
        <PPMobileCardView
            title={moment(data.date).format("DD-MM-YYYY")}
            id={data.id}
            rows={rows}
            menuItems={menuItems}
        />
    );
};

export default Mobile;
